
import { API_JAVA_BUSCA_CONTRATO_REGISTRO, API_JAVA_CONSULTA_PERFIL_SERVICO, API_JAVA_CONSULTA_RESTRITO_FUG, API_JAVA_CONSULTA_RESTRITO_ISO, API_JAVA_GRAVA, API_JAVA_RENOVA, API_JAVA_CONSULTA_SITUACAO_CERT  } from '../app.api';  //API_JAVA_CERT_VAL   API_JAVA_OBTER_PERFIL
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, OnInit, NgZone } from '@angular/core';
import { MessageService } from './message.service';
import { HttpUtilService } from './http-util.service';
import { Router } from '@angular/router';
import { PerfisServicosModel } from '../model/perfis-servicos.model';
import { DadosIsoFugModel, EntradaIsoFugModel } from '../model/dados-iso-fug.model';
import { DadosGravaModel } from '../model/dados-grava.model';
import { DadosBuscaContratoModel } from '../model/dados-busca-contrato.model';
import DadosCertificadoModel from '../model/dados-certificado.model';
import DadosRegistroModel from '../model/dados-registro.model';
import { DadosRenovaModel } from '../model/dados-renova.model';
import { Observable, of } from 'rxjs';
import{ GlobalCripto } from './../global/global-constants';

@Injectable({
  providedIn: 'root'
})
export class RegistroService {
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private httpUtilService: HttpUtilService,
    private zone: NgZone,
    private router: Router) { }
 
  private sign: any ;
  private messageError: [number, string];
  private messageSucess: [number, string];
  private listaServicos: any;
  private certificadoBloqueado: boolean;
  private certificadoValido: boolean;
  private certificadoAutorizado = false;
  private outorgado;
  listaPerfisServcos: PerfisServicosModel[] = [];
  dadosIsoFug: DadosIsoFugModel;
  parameters = new EntradaIsoFugModel();

  OnInit() {
    this.messageService.currentErrorMessage.subscribe(messageError => {
      if (messageError) { this.messageError = [messageError[0], messageError[1]]; }
    });
    this.messageService.currentSucessMessage.subscribe(messageSucess => {
      if (messageSucess) { this.messageSucess = [messageSucess[0], messageSucess[1]]; }
    });
   
  if (!GlobalCripto.clientAPI) {
    console.log(' ClientAPI não foi instanciado...')
  }
  }
 
async listaPerfis() {   

   await this.httpUtilService.post(API_JAVA_CONSULTA_PERFIL_SERVICO, JSON.stringify(""))
    .toPromise().then(data => {

      if(data === undefined || data['errors'].length > 0){
        
        const erro = data['errors'][0];
        this.messageService.changeErrorMessage(+erro.status, erro.mensagem + 'Sistema indisponível. Favor tente mais tarde.');
        this.router.navigate(['/acesso-negado']);        

      } else {        
        this.listaPerfisServcos = data['data']['resultSetServicoDto'];
      }

    }, err => {
      console.error(err)
      this.messageService.changeErrorMessage(err.error.errors[0].status, err.error.errors[0].mensagem);
      this.router.navigate(['/acesso-negado']);
    });
    return this.listaPerfisServcos;
}

  async consultaFugServlet(parameters: EntradaIsoFugModel) {

    const retorno = await this.httpUtilService.post(API_JAVA_CONSULTA_RESTRITO_FUG, JSON.stringify(parameters))
      .toPromise().then(dados => {
        this.dadosIsoFug = dados['data'];

      }, err => {
        console.error(err)
        this.messageService.changeErrorMessage(err.error.status, err.error.message);
        this.router.navigate(['/acesso-negado']);
        return this.certificadoBloqueado = true;
      });

    return this.dadosIsoFug;
  }

  async consultaIsoServlet(parameters: EntradaIsoFugModel) {

    const retorno = await this.httpUtilService.post(API_JAVA_CONSULTA_RESTRITO_ISO, JSON.stringify(parameters))
      .toPromise().then(dados => {
        this.dadosIsoFug = dados['data'];

      }, err => {
        console.error(err)
        this.messageService.changeErrorMessage(err.error.status, err.error.message);
        this.router.navigate(['/acesso-negado']);
        return this.certificadoBloqueado = true;
      });

    return this.dadosIsoFug;
  }


  async grava(parameters: DadosGravaModel) {
    let mensagem: string[];
    const retorno = await this.httpUtilService.post(API_JAVA_GRAVA, JSON.stringify(parameters))
      .toPromise().then(dados => {

        mensagem = dados['data'];

      }, err => {
        console.error(err)
        this.messageService.changeErrorMessage(err.error.errors[0].status, err.error.errors[0].mensagem);
        this.router.navigate(['/acesso-negado']);
        return this.certificadoBloqueado = true;
      });

    return mensagem;
  }

  async renova(parameters: DadosRenovaModel) {
    let mensagem: string[];
    const retorno = await this.httpUtilService.post(API_JAVA_RENOVA, JSON.stringify(parameters))
      .toPromise().then(dados => {

        mensagem = dados['data'];

      }, err => {
        console.error(err)
        this.messageService.changeErrorMessage(err.error.errors[0].status, err.error.errors[0].mensagem);
        this.router.navigate(['/acesso-negado']);
        return this.certificadoBloqueado = true;
      });

    return mensagem;
  }

  public converteToObjectlistaPerfisServicos(data: any): PerfisServicosModel[] {

    data.map((item, index) => {
      const itemPerfil = new PerfisServicosModel();
      itemPerfil.idPerfil = item.idPerfil;
      itemPerfil.descPerfil = item.descPerfil;
      itemPerfil.tipoPerfil = item.tipoPerfil;
      itemPerfil.tipoRestricao = item.tipoRestricao;
      itemPerfil.inscricaoAprovacao = item.inscricaoAprovacao;
      itemPerfil.grupos = item.grupos;
      //itemPerfil.grupos.servicos = item.grupos.servicos;
      this.listaPerfisServcos.push(itemPerfil);
    });
    return this.listaPerfisServcos;
  }

  async buscaContratoRegistro(contrato: DadosBuscaContratoModel) {
    let dados: any;
    const retorno = await this.httpUtilService.post(API_JAVA_BUSCA_CONTRATO_REGISTRO, JSON.stringify(contrato))
      .toPromise().then(data => {
        dados = data;
      }, err => {
        console.error(err);
        // this.messageService.changeErrorMessage(null, err.error.errors[0].mensagem);
        // this.router.navigate(['/acesso-negado']);
        return;
      });
    return dados;
  }
 
  private getNomeEntidadeCert(certificado): string {
    if (!certificado || !certificado.issuer || !certificado.issuer.name) {
      console.error('Certificado ou issuer não encontrado');
      return '';
    }
    const nomeEntidadeCert: string = certificado.issuer.name.split(',')[0].split('=')[1];
    return nomeEntidadeCert;
  }


  /**
   * Chamada ao REST que traz Situacao do Registro.
   * @param codigoSerial 
   * @param no_entidade_cert 
   */
  consultaServicoSituacaoCertificado(codigoSerial: string, no_entidade_cert: string): Observable<any> {
  const body = {
      codigoSerial: codigoSerial,
      autoridadeCertificadora: no_entidade_cert
  };

  return this.http.post(
      API_JAVA_CONSULTA_SITUACAO_CERT,
      body,
      this.httpUtilService.headers()
  );
}


  consultarSituacaoRegistro(certificado: DadosCertificadoModel): Observable<DadosRegistroModel> {
    const nomeAutCert = this.getNomeEntidadeCert(certificado);
    return this.consultaServicoSituacaoCertificado(certificado.codigoSerial + '', nomeAutCert);
  }

  isInscricaoBloqueada(registro: DadosRegistroModel){
    if(registro !== undefined && registro.bloqueado){
      this.messageService.changeErrorMessage(null, 'Não é possível realizar o registro. Acusamos o BLOQUEIO da inscrição CNPJ/ CEI e/ou CPF no Conectividade Social. Favor acionar a central de tele serviços CAIXA conforme orientações no site WWW.CAIXA.GOV.BR/ATENDIMENTO');
      this.router.navigate(['/acesso-negado']);
    }
  }

  /**
   * Trata mensagens para Situacoes do Registro consideradas Invalidas.
   * @param situacao situacao invalida do Registro
   */
  public trataRegistroInvalido(situacao: number) {
    const index = 0;
    switch (situacao) {
      case 0:
        this.messageService.changeErrorMessage(index, 'Certificado Não Registrado !');
        break;
      case 1:
        this.messageService.changeErrorMessage(situacao, 'Pré–registro já efetuado.');
        break;
      case 2:
        this.messageService.changeErrorMessage(situacao, 'Certificado já Autorizado !');
        break;
      case 3:
        this.messageService.changeErrorMessage(situacao,'Identificamos que seu certificado digital/token conectividade encontra-se não autorizado.');
        break;
      case 4:
        this.messageService.changeErrorMessage(situacao, 'Identificamos que seu certificado digital/token conectividade encontra-se revogado.');
        break;
      case 5:
        this.messageService.changeErrorMessage(situacao, 'Não é possível realizar o registro. Acusamos o suspensão do registro. Favor acionar a central de tele serviços CAIXA conforme orientações no site WWW.CAIXA.GOV.BR/ATENDIMENTO');
        break;
      case 7:
        this.messageService.changeErrorMessage(situacao, 'Usuário Revogou !');
        break;
      default:
        this.messageService.changeErrorMessage(situacao, 'Certificado inválido !');
    }
  }

  /**
   * 
   * @param dadosRegistro 
   * @returns 
   */
  public async tratarSituacaoRegistro(dadosRegistro: DadosRegistroModel): Promise<boolean> {

    return new Promise<boolean>(resolve => {

      if (dadosRegistro === undefined) {
        dadosRegistro = new DadosRegistroModel();
        dadosRegistro.situacao = 0;
      }

      if (dadosRegistro.situacao !== 2) {
        this.trataRegistroInvalido(dadosRegistro.situacao);
        this.router.navigate(['/acesso-negado']);
      }

      resolve(true);
    });
  }
}